import React from 'react';
import classNames from 'classnames';
import shallow from 'zustand/shallow';
import { FormInputElement } from '@typedream/core';
import { setNodes } from '@udecode/plate-core';
import { debounce } from 'lodash';
import styles from '../SideToolbar.module.css';
import { getSelectedElementEntry } from '../../../plugins/elementSelection';
import { useDreamEditorStore } from '../../../plugins/store';
import { useTPlateEditorRef } from '../../../plate';

function InputPlaceholder() {
  const editor = useTPlateEditorRef();

  const [originalPlaceholder, elementId] = useDreamEditorStore(() => {
    const entry = getSelectedElementEntry(editor);
    if (!entry) return '';
    const [element] = entry;
    return [(element as FormInputElement)?.placeholder, element.id];
  }, shallow);

  const handleSavePlaceholder = React.useCallback(
    debounce((value) => {
      const entry = getSelectedElementEntry(editor);
      if (!entry) return;

      const [, path] = entry;

      setNodes(
        editor,
        {
          placeholder: value,
        },
        {
          at: path,
        },
      );
    }, 500),
    [editor],
  );

  const onLabelChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      handleSavePlaceholder(e.target.value);
    },
    [handleSavePlaceholder],
  );

  return (
    <div className="mt-5 mb-5">
      <div className={styles.label}>
        Placeholder
      </div>

      <input
        key={`toolbar-input-${elementId}`}
        className={classNames(styles.input)}
        type="text"
        placeholder="e.g"
        defaultValue={originalPlaceholder}
        onChange={onLabelChange}
      />
    </div>
  );
}

export default InputPlaceholder;
